import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import styles from './ExperienceMessage.module.css';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import iconDelete from '../../../images/icon-red-delete.svg';
import { useDispatch, useSelector } from 'react-redux';
import { addTourMessage, deleteTourMessage, getTourMessage, removePrevTourData } from '../../../redux/tour/actions/tourExperience.action';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import Loader from '../../common/loader/Loader';
import { MessageData } from '../interfaces/locations.interface';

interface ExperienceMessageProps {
    type: string | undefined;
    locationData: string | undefined;
    setMessage: Dispatch<SetStateAction<MessageData[]>>;
    message: MessageData[];
}

interface TourData {
    created_at: string;
    header: string;
    id: number;
    location: string;
    message: string;
    subId: string;
    updated_at: string;
    index?: number;
}

const ExperienceMessage = ({ type, locationData, message, setMessage }: ExperienceMessageProps) => {
    const dispatch: AppDispatch = useDispatch();

    const tour = useSelector((state: IRootState) => state.tourExperience.data.experienceMessage);
    const loader = useSelector((state: IRootState) => state.tourExperience.loading);

    const [hasMoreQuestion, setHasMoreQuestion] = useState(false);
    const [data, setData] = useState<MessageData[]>([]);
    const [faqData, setFaqData] = useState({ header: '', message: '' });

    useEffect(() => {
        if (type === 'add') {
            dispatch(removePrevTourData());
            setData([]);
        }
    }, [type]);

    useEffect(() => {
        if (locationData) {
            type === 'edit' && dispatch(getTourMessage(locationData));
        }
    }, [locationData]);

    const addDataHandler = () => {
        if (faqData.message === '' || faqData.header === '') {
            return;
        } else {
            if (type === 'add') {
                setMessage([...message, { id: message.length + 1, header: faqData.header, message: faqData.message }]);
                setData([...data, { id: data.length + 1, message: faqData.message, header: faqData.header }]);
            } else {
                const TourMessage = {
                    location: locationData,
                    tourExperienceMessages: [
                        {
                            header: faqData.header,
                            message: faqData.message,
                        },
                    ],
                };

                if (faqData.header.trim() !== '' && faqData.message.trim() !== '') {
                    dispatch(addTourMessage(TourMessage, locationData));
                }
            }
            setFaqData({ header: '', message: '' });
            setHasMoreQuestion(false);
        }
    };

    const removeDataHandler = async (tourData: TourData | number) => {
        if (typeof tourData === 'number') {
            if (type === 'add') {
                const filteredArray = message.filter((_, index) => index !== tourData);
                setMessage(filteredArray);
            } else {
                const filteredArray = data.filter((_, index) => index !== tourData);
                setData(filteredArray);
            }
        } else {
            dispatch(deleteTourMessage(tourData.subId, tourData.location));
        }
    };

    useEffect(() => {
        if (tour && tour.length) {
            const arr = tour?.map((el: TourData, index: number) => {
                return {
                    ...el,
                    id: index + 1,
                    subId: el.id,
                };
            });
            setData(arr);
        }
    }, [tour]);

    return (
        <>
            {loader ? (
                <Loader />
            ) : (
                <div className={styles.container}>
                    <div className={styles.header}>
                        <h2 className={styles.title}>Tour experience message</h2>
                    </div>
                    <div className={styles.modalBody}>
                        <div className={styles.dragContainer}>
                            {((type === 'edit' && tour?.length > 0) || (type === 'add' && !tour?.length && !!message.length)) && (
                                <RLDD
                                    items={type === 'add' ? message : data}
                                    itemRenderer={(item: TourData, index: number) => {
                                        return (
                                            <div className={styles.dragItem}>
                                                <div className={styles.msgContainer}>
                                                    <div className={styles.msgWrapper}>
                                                        <img
                                                            onClick={() => removeDataHandler(type === 'add' ? index : item)}
                                                            className={styles.iconDelete}
                                                            src={iconDelete}
                                                            alt="Delete"
                                                        />
                                                        <div className={styles.titleWrapper}>
                                                            <h2 className={styles.msgTitle}>{item.header}</h2>
                                                        </div>
                                                        <div className={styles.msgDesc}>
                                                            <p>{item.message}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }}
                                    onChange={(newItems: MessageData[]) => {
                                        setData(newItems);
                                    }}
                                />
                            )}
                        </div>
                        {hasMoreQuestion && (
                            <div className={styles.addMsgContainer}>
                                <form onSubmit={(e) => e.preventDefault()} className={styles.addMsgForm}>
                                    <input
                                        value={faqData.header}
                                        onChange={(e) => setFaqData({ ...faqData, header: e.target.value })}
                                        type="text"
                                        placeholder="Add your header"
                                    />
                                    <textarea
                                        value={faqData.message}
                                        onChange={(e) => setFaqData({ ...faqData, message: e.target.value })}
                                        placeholder="Add your message"
                                    />
                                    <div className={styles.btnWrapper}>
                                        <button
                                            onClick={() => {
                                                setHasMoreQuestion(false);
                                                setFaqData({ header: '', message: '' });
                                            }}
                                            type="button">
                                            Cancel
                                        </button>
                                        <button onClick={addDataHandler} type="button" className={styles.save}>
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )}
                        <button onClick={() => setHasMoreQuestion(true)} type="button" className={styles.addNewMsg}>
                            + add new message
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ExperienceMessage;
